import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { formatUsdCents, formatYyyymmddDisplay } from '../formatters';
import { BiTimeChart } from './BiTimeChart';

/**
 * Linha de ARPT (receita média por tenant, USD eq.) por dia do período, no `/dashboard/finance`.
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200 (charts série temporal + ARPT).
 *
 * Contrato: plota `mrr.arptUsdCents / 100` (eixo em dólares) e reconverte para centavos no
 * `valueFormatter` — `formatUsdCents` recebe CENTAVOS; esquecer o `× 100` exibe 100× menor.
 *
 * Usado por: `FinanceDashboardPage` (web `apps/admin`, super-admin).
 *
 * Histórico:
 *  - 2026-06-09 00:31 +0200 — (39-G) Recharts → Cloudscape via `BiTimeChart`.
 */
export function ArptChart({ series }: { series: readonly DailyAggregate[] }): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.mrr.arptUsdCents / 100,
  }));
  return (
    <BiTimeChart
      title={t('finance.charts.arpt')}
      subtitle={t('finance.charts.usdAxis')}
      type="line"
      data={data}
      color="#f97316"
      valueFormatter={(v): string => formatUsdCents(Math.round(v * 100))}
    />
  );
}
